import MD5 from "js-md5";
const imgHost = 'https://cdn.ysqingxin.com/'
export const serialize = (obj) => {
    let str=Object.keys(obj).map((item) => `${item}=${obj[item]}`).join("&")
    let string
    if(str){
        string=str+`&key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
    }else{
        string=str+`key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
    }
    // console.log(string)

    let sign=MD5(string)
    return str+`&sign=${sign}`
}

export function getQueryString(name) {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return '';
}

export function storeLoginInfo(doctor) {
  localStorage.setItem("doctorId", doctor.doctorId);
  localStorage.setItem("companyId", doctor.companyId);
  localStorage.setItem("doctorPhone", doctor.doctorPhone);
  localStorage.setItem("doctorName", doctor.doctorName);
  localStorage.setItem('teacherInfo', JSON.stringify(doctor))
}

export function clearLoginInfo() {
  localStorage.removeItem("doctorId");
  localStorage.removeItem("companyId");
  localStorage.removeItem("doctorPhone");
  localStorage.removeItem("doctorName");
  localStorage.removeItem('teacherInfo')
}

export function getImage(photoImg) {
  if (!photoImg) return '/static/img/logo.768f1db.png'
  if (photoImg.indexOf('http') >= 0) return photoImg
  return imgHost + photoImg
}

export function convertObj2Array(obj) {
  const array = []
  for (const k in obj) {
    const v = obj[k]
    array.push({ value: k, label: v })
  }
  return array
}

export function checkLogin() {
  const teacherInfo = localStorage.getItem('teacherInfo')
    // console.log('checkLogin: teacherInfo', teacherInfo)
  if (isBlank(teacherInfo)) {
    alert('请先登录')
    location.href = `/#/wx-auth?redirectUrl=${encodeURIComponent(location.href)}`
    return false
  }
  return true
}

export function isBlank(v) {
  // console.log('isBlank', v)
  return !v || v === 'null' || v === 'undefined'|| typeof v === 'undefined'
}

export function origin() {
  let origin = window.location.origin
  if (!origin)
    origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  return origin
}



// WEBPACK FOOTER //
// ./src/utils/index.js